import { forwardRef, type Ref, type SVGProps } from "react";
const IconStreetViewOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M12 19h.22l.33 3 .35 3.12A2.14 2.14 0 0 0 15 27h2a2.14 2.14 0 0 0 2.1-1.88l.68-6.12H20a2.51 2.51 0 0 0 2.05-1 2.48 2.48 0 0 0 .33-2.23l-1.25-4.17A4.37 4.37 0 0 0 18.66 9a4 4 0 1 0-5.32 0 4.37 4.37 0 0 0-2.47 2.66L9.62 15.8A2.48 2.48 0 0 0 10 18a2.51 2.51 0 0 0 2 1m4-15a2 2 0 1 1-2 2 2 2 0 0 1 2-2m-4.47 12.37 1.25-4.17a2.29 2.29 0 0 1 1.56-1.46 13 13 0 0 1 1.66-.09 13 13 0 0 1 1.66.09 2.29 2.29 0 0 1 1.56 1.46l1.25 4.17a.52.52 0 0 1 0 .47.53.53 0 0 1-.47.16h-2l-.87 7.9a.17.17 0 0 1-.13.1h-2a.17.17 0 0 1-.12-.1L14 17h-2a.53.53 0 0 1-.44-.16.52.52 0 0 1-.03-.47"
    />
    <path
      fill="currentColor"
      d="m21.42 22.31-.22 2A18.3 18.3 0 0 1 27.66 26c-1.35.83-5.39 2-11.66 2S5.69 26.83 4.34 26a18.3 18.3 0 0 1 6.46-1.71l-.22-2C5.54 22.92 2 24.34 2 26c0 2.21 6.27 4 14 4s14-1.79 14-4c0-1.66-3.54-3.08-8.58-3.69"
    />
  </svg>
);
const ForwardRef = forwardRef(IconStreetViewOutlineSVG);
ForwardRef.displayName = "IconStreetViewOutline";
export { ForwardRef as IconStreetViewOutline };
